import React from "react"
import PropTypes from "prop-types"
import {findDOMNode} from "react-dom"

import Popover from "src/core/gd-components/gd-popover/popover"
import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll"
import SelectMultiGenericPopoverSearch from "./popover-search"
import SelectMultiGenericPopoverOptionsSelector from "./popover-options-selector"

const SEARCH_SHOW_THRESHOLD = 6; // min options to show search input

export default class SelectMultiGenericPopoverMenu extends React.Component {

    static propTypes = {
        parent                          : PropTypes.object,

        options                         : PropTypes.array,

        allValuesOptionLabel            : PropTypes.string,
        allValuesOption                 : PropTypes.bool,   // is all values option available

        popoverClasses                  : PropTypes.string,
        popoverScrollContainerClasses   : PropTypes.string,

        isSearchable                    : PropTypes.bool,

        popoverOptionComponent          : PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            searchString: null
        }
    }

    onPopoverKeyDown = (e) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString) => {
        this.setState({
            searchString: newSearchString
        })
    }

    updateScroll = (node) => {
        if (!this.scroll) return

        const scrollNode = findDOMNode(this.scroll.childrenContainer)

        const nodeTop = node.offsetTop
        const nodeBottom = node.offsetTop + node.offsetHeight
        const scrollTop = scrollNode.scrollTop
        const scrollBottom = scrollNode.scrollTop + scrollNode.offsetHeight

        // ensure node to be in visible area of scroll
        if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop) this.scroll.setScrollTop(nodeTop, false, 100)
    }

    render() {
        return (
            <Popover attachment         = "top center"
                     targetAttachment   = "bottom center"
                     getTargetFunc      = {()=>findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {()=>{this.props.parent.hidePopover()}}>

                <SelectMultiGenericPopoverSearch searchable        = {this.props.isSearchable && this.props.options.length > SEARCH_SHOW_THRESHOLD}
                                                 searchString      = {this.state.searchString}
                                                 onHidePopover     = {this.props.parent.hidePopover}
                                                 onSearchChange    = {this.onSearchChange}/>

                <div className={Classes("ui5-popover-menu", this.props.popoverClasses)}>
                    <VScroll ref={r=>this.scroll = r} minDragHeight={20} containerClass={this.props.popoverScrollContainerClasses} scrollVisibility="auto">
                        <SelectMultiGenericPopoverOptionsSelector ref              = {r=>this.optionsSelector = r}
                                                                  {...this.props}
                                                                  searchString     = {this.state.searchString}
                                                                  onUpdateScroll   = {this.updateScroll}/>
                    </VScroll>
                </div>
            </Popover>
        )
    }
}
